/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DropdownOption from 'DesignSystem/DropdownOption/index'
import React from 'react'
import ViewsStream from 'Simple/Stream/react-dom'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function DropdownOptions({
  children,
  viewPath = "/DesignSystem/DropdownOptions",
  left = "auto",
  right = "auto",
  top = 32,
  transformOriginY = "left",
  width = 200,
  height = 350,
  from,
  fontSize,
  isMultiChoice,
  field,
  isSelected,
  onClick,
  id
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="DropdownOptions.Vertical"
  data-view-path={viewPath}
 style={{'--l-1-Z9B6oP': typeof left === 'number' ? `${left}px` : left,'--r-3-Z9B6oP': typeof right === 'number' ? `${right}px` : right,'--t-4-Z9B6oP': typeof top === 'number' ? `${top}px` : top,'--toy-5-Z9B6oP': transformOriginY,'--w-7-Z9B6oP': typeof width === 'number' ? `${width}px` : width,'--h-8-Z9B6oP': typeof height === 'number' ? `${height}px` : height,'--o-2-Z9B6oP': isBefore ? 0 : 1,'--ty-6-Z9B6oP': isBefore ? "-10px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DropdownOptions.List"
  data-view-path={viewPath}
 className="views-block"
>
<ViewsStream
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="dropdown_option"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/DropdownOption(${item?.id ?? item?._id ?? index})`}
      >
<DropdownOption
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/DropdownOption(${item?.id ?? item?._id ?? index})`}
 fontSize={fontSize}
 isMultiChoice={isMultiChoice}
 field={field}
 isSelected={isSelected}
 onClick={onClick}
 id={id}
/>
</ListItem>
)}
</ViewsStream>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }